import { Component } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import CategoryGroup from './category-group'
import List from './list'
import Link from './link'
import ChevronDown from '../assets/icon-chevron-down'
import Dropdown from '../dropdown/index'

export default class extends Component {
  render ({
    communityCategories,
    knowledgeBaseCategories,
    showActivitySinceLastVisit
  }) {
    return <div class='main-menu'>
      <Dropdown
        class={'dropdown dropdown--forums-overview'}
        trigger={
          <span style={{ display: 'flex', alignItems: 'center' }} class='main-menu-trigger'>
            <span><Phrase m='Common' p='main.navigation.menu_label' /></span>
            <ChevronDown />
          </span>
        }
      >
        <span class='arrow is-hidden-S' />

        <List class='main-menu-list--overflow-scroll'>
          <List>
            <Link href='/'>
              <Phrase m='Common' p='nav.title.forum.overview' />
            </Link>

            <Link
              href='/search/activity/recent'>
              <Phrase m='Common' p='nav.title.forum.recent.activity' />
            </Link>

            {showActivitySinceLastVisit
              ? <Link
                href='/search/activity/sincelastvisit'>
                <Phrase m='Common' p='nav.title.forum.activity.last.visit' />
              </Link>
              : null
            }

            <Link
              href='/search/activity/unanswered'>
              <Phrase m='Common' p='nav.title.forum.unanswered.questions' />
            </Link>
          </List>

          {knowledgeBaseCategories.length
            ? <section class='main-menu-section'>
              <div class='main-menu-section__title'>
                <Phrase p='nav.title.knowledgebase' />
              </div>

              {knowledgeBaseCategories.map(parentCategory => {
                return <CategoryGroup
                  key={parentCategory.id}
                  url={parentCategory.url}
                  title={parentCategory.title}
                  categories={parentCategory.subforums} />
              })}
            </section>
            : null}

          {communityCategories.length
            ? <section class='main-menu-section'>
              <div class='main-menu-section__title'>
                <Phrase p='nav.title.community' />
              </div>

              {communityCategories.map(parentCategory => {
                return <CategoryGroup
                  key={parentCategory.id}
                  url={parentCategory.url}
                  title={parentCategory.title}
                  categories={parentCategory.subforums} />
              })}

            </section>
            : null}
        </List>
      </Dropdown>
    </div>
  }
}
